<template>
    <div class="footer" @click="handleClick">
        立即支付
    </div>
</template>
<script>
export default {
    methods:{
      handleClick() {
        this.$emit('pay')
      }
    }
}
</script>
<style lang="stylus" scoped>
    .footer
      position fixed
      left 0
      bottom 0
      width 100%
      height 80px
      line-height 80px
      background #2852A6
      color #ffffff
      font-size 30px
      text-align center
  @media screen and (min-width: 800px)
    .footer
      position relative
      left 50%
      bottom 0
      transform translateX(-50%)
      margin-top 20px
      width 240px
      height 60px
      line-height 60px
      background #2852A6
      color #ffffff
      font-size 30px
      text-align center
</style>